<template>
  <div class="section section_big-padding-top">
    <div class="max-width">
      <div class="themes">

        <div class="section__head section__head_middle">
          <div class="section__subheading fadeIn">Featured</div>
          <h2 class="section__title">Themes</h2>
          <div class="section__text">Uncover our themes — create a stunning, conversion-ready storefront in hours.</div>
        </div>

        <div class="themes__list">
          <div
              v-for="theme in themesFiltered"
              :key="theme.id"
              class="themes__item "
          >
            <router-link
                :to="`/themes/${theme.id}`"
                class="themes__pic fadeIn"
                :class="`themes__pic_${theme.id}`"
            >
              <img loading="lazy" :srcset="theme.image.srcset" :src="theme.image.src" :alt="theme.image.alt" />
            </router-link>

            <div class="themes__about fadeIn">
              <div v-if="theme.featured" class="themes__popular">
                <IconPopular/>
                Featured Theme
              </div>

              <h3 class="themes__title"><router-link :to="`/themes/${theme.id}`">{{ theme.title }}</router-link></h3>
              <div class="themes__desc">{{ theme.desc }}</div>

              <div class="themes__actions">
                <router-link :to="`/themes/${theme.id}`" class="button">
                  Explore {{ theme.title }}
                  <IconArrow/>
                </router-link>

                <a :href="theme.shopifyLink" class="button button_white-border button_shopify" target="_blank">
                  View on Shopify
                  <IconShopify/>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import IconArrow from "@/components/icons/IconArrow.vue";
import IconShopify from "@/components/icons/IconShopify.vue";
import IconPopular from "@/components/icons/IconPopular.vue";

const themes = ref([])

onMounted(async () => {
  const res = await fetch('/assets/json/themes.json')
  themes.value = await res.json()
})

const currentListId = 'featured'

const themesFiltered = computed(() => {
  return themes.value.filter(
      theme => !theme.hiddenIn?.includes(currentListId)
  )
})
</script>

<style lang="scss">
.themes {
  &__list {
    display: flex;
    gap: 4.5rem;
    flex-direction: column;

    @include md {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap:1.25rem;

      &:has(.themes__item:nth-child(2)) {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    @include xs {
      gap: 3rem;
      grid-template-columns: repeat(1, 1fr);
    }
  }

  &__item {
    display: flex;
    gap: 1.25rem;
    justify-content: space-between;

    @include lg {
      flex-direction: column;
    }
  }

  &__pic {
    flex: auto;

    @include lg {
      width: 100%;
    }

    img {
      width: 100%;
      border-radius:24px;
    }
  }

  &__about {
    flex: none;
    width: 41%;
    background:var(--color-gray-light);
    display:flex;
    flex-direction:column;
    padding:2.5rem;
    border-radius:24px;
    align-items:flex-start;

    @include xl {
      padding:2rem;
    }

    @include lg {
      width: 100%;
    }

    @include xs {
      padding:1.5rem;
    }
  }

  &__popular {
    margin: 0 0 22px;
    display: flex;
    align-items: center;
    color: #4d4d54;
    gap: 4px;
    font-size: .875rem;
    background: #e8e8e8;
    font-weight: 600;
    letter-spacing: 0.02em;
    height:34px;
    text-transform: uppercase;
    padding:0 .75rem;
    border-radius:100px;
    padding-top:2px;

    svg {
      opacity:.6;
    }
  }

  &__title {
    font-size: 6rem;
    line-height: 1;
    letter-spacing: -0.02em;
    font-weight: 400;

    @include xl {
      font-size:5rem;
    }

    @include lg {
      font-size:4rem;
      margin:0 0 2rem;
    }

    a:hover {
      opacity:.7;
    }
  }

  &__desc {
    margin: auto 0 0;

    @include lg {
      font-size:1rem;
    }
  }

  &__actions {
    display: flex;
    gap: .75rem;
    margin: 2rem 0 0;

    @include xl {
      margin-top:1.5rem;
      width:100%;

      .button {
        padding:0;
        flex:auto;
      }
    }

    @include md {
      flex-direction: column;
    }
  }
}
</style>
